import axios from 'axios';
import Vue from 'vue'

export default {

    checkGiftByItemRef (itemRef) {
        return axios.get('/api/gift/check/item', { params: { itemRef: itemRef} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    checkGift(code) {
        return axios.get('/api/gift/check', { params: { code: code} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveGiftWinner (giftWinner) {
        return axios.post('/api/gift/winner/save', giftWinner)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },

    
}
